import { createElement, HTMLAttributes } from 'react';
import cx from 'classnames';

export type HeadingSize = 'xl' | 'lg' | 'md' | 'sm' | 'xs';
type HeadingTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

export interface HeadingProps extends HTMLAttributes<HTMLHeadingElement> {
  /** `xl` page title, `lg` dialog or block title, `md` section, `sm` subsection, `xs` a group inside a side panel. */
  size?: HeadingSize;
  /** The outline level, when it differs from the one the size implies. */
  as?: HeadingTag;
  /** `inverse` on dark surfaces. */
  tone?: 'default' | 'inverse';
}

const sizeClasses: Record<HeadingSize, string> = {
  xl: 'text-heading-xl',
  lg: 'text-heading-lg',
  md: 'text-heading-md',
  sm: 'text-heading-sm',
  xs: 'text-heading-xs',
};

const defaultTag: Record<HeadingSize, HeadingTag> = { xl: 'h1', lg: 'h2', md: 'h2', sm: 'h3', xs: 'h4' };

/** The one heading of the app. Spacing around it belongs to the caller's `className`; type does not. */
export const Heading = ({ size = 'md', as, tone = 'default', className, ...rest }: HeadingProps) =>
  createElement(as ?? defaultTag[size], {
    className: cx(tone === 'inverse' ? 'text-white' : 'text-ink', sizeClasses[size], className),
    ...rest,
  });
